import styled from 'styled-components';

interface PropsShow {
  show?: boolean;
}

export const Container = styled.div<PropsShow>`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
`;

export const NotFoundContent = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 2rem 1rem 0;

  @media (min-width: 1024px) {
    padding: 2rem 2rem 0;
  }

  @media (min-width: 1536px) {
    padding: 2rem 8rem 0;
  }

  button {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    border: none;
    background: transparent;
    color: var(--color-primary);
    font-weight: 500;
    cursor: pointer;

    .icon {
      font-size: 1.1rem;
    }
  }
`;
